import React from 'react';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import ReactHtmlParser from 'html-react-parser';
import Select from 'react-select';
import { map } from 'lodash';

class EditSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      times: '',
      option: ''
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index, checkSurveyState } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers, () => {
        checkSurveyState(this);
      });
    } else {
      // storeAnswer(index, this.state);
    }
  }

  handleChange = type => e => {
    const { storeAnswer, questionId } = this.props;
    const value = e.target.value;
    if (value.length > 2 || !/^[0-9]*$/.test(value)) {
      return;
    }
    this.setState({ [type]: value }, () => {
      storeAnswer(questionId, this.state, this.isQuestionAnswered());
      // checkSurveyState(this);
    });
  };

  onOptionSelect = e => {
    const { storeAnswer, questionId } = this.props;
    this.setState({ option: e.value }, () => {
      if (this.state.times) {
        storeAnswer(questionId, this.state, this.isQuestionAnswered());
        // checkSurveyState(this);
      }
    });
  };

  isQuestionAnswered = () => {
    return !!(this.state.times && this.state.option);
  };

  render() {
    const {
      text,
      question,
      className,
      dropdown,
      customDDWidth = '20%'
    } = this.props;
    return (
      <div className={`${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <Flex align="end">
          <Flex align="center" width={text.width || '18%'}>
            <input
              type="number"
              max={text.max}
              onChange={this.handleChange('times')}
              value={this.state.times}
              className={`survey-text survey-item-${text.size}`}
            />
          </Flex>
          <Element marginLeft="16px" width={customDDWidth}>
            <Select
              options={map(dropdown.options, option => ({
                label: option,
                value: option
              }))}
              placeholder=""
              onChange={this.onOptionSelect}
              value={this.state.option}
              searchable={false}
              clearable={false}
              width={customDDWidth}
            />
          </Element>
        </Flex>
      </div>
    );
  }
}

export default EditSelect;
